import TeamNode from './TeamNode';
import GironeNode from './GironeNode';
import ClassificaNode from './ClassificaNode';
import DiretteNode from './DiretteNode';

// Oggetto stabile a livello di modulo (React Flow richiede identità stabile per nodeTypes)
const nodeTypes = {
  team: TeamNode,
  girone: GironeNode,
  classifica: ClassificaNode,
  dirette: DiretteNode,
};

export default nodeTypes;
